var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmoticonSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "#F4BF2C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8812 26.9166H27.4687V30.2291H14.8812V26.9166Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5177 20.2916C30.2556 20.2916 31.6646 18.8086 31.6646 16.9791C31.6646 15.1497 30.2556 13.6666 28.5177 13.6666C26.7797 13.6666 25.3708 15.1497 25.3708 16.9791C25.3708 18.8086 26.7797 20.2916 28.5177 20.2916Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8323 20.2916C15.5702 20.2916 16.9791 18.8086 16.9791 16.9791C16.9791 15.1497 15.5702 13.6666 13.8323 13.6666C12.0943 13.6666 10.6854 15.1497 10.6854 16.9791C10.6854 18.8086 12.0943 20.2916 13.8323 20.2916Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.154 0.416626C9.57349 0.416626 0.195801 10.31 0.195801 22.5C0.195801 34.69 9.57349 44.5833 21.154 44.5833C32.7555 44.5833 42.1541 34.69 42.1541 22.5C42.1541 10.31 32.7555 0.416626 21.154 0.416626ZM21.175 40.1666C11.9022 40.1666 4.39163 32.2608 4.39163 22.5C4.39163 12.7391 11.9022 4.83329 21.175 4.83329C30.4478 4.83329 37.9583 12.7391 37.9583 22.5C37.9583 32.2608 30.4478 40.1666 21.175 40.1666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoticonSad);
export default __webpack_public_path__ + "static/media/emoticon-sad.0ae9c1dfb7dc2f0a6696227467654e02.svg";
export { ForwardRef as ReactComponent };